import { FunctionComponent, memo, useState } from "react";
import { IProps } from "./metabase-dashboard.types";
import useMetabaseToken from "hooks-for/custom-reports/use-metabase-token";
import { Page, PageHeader } from "@edgetier/client-components";
import { Spinner, SpinnerUntil } from "@edgetier/components";
import { useParams } from "react-router-dom";
import { METABASE_SITE_URL } from "./metabase-dashboard.constants";
import { ShowSidebarButton, SidebarContainer } from "@edgetier/sidebar";
import CustomReportsSidebar from "../custom-reports-sidebar";
import "./metabase-dashboard.scss";

/**
 * An iframe showing a metabase dashboard.
 */
const MetabaseDashboard: FunctionComponent<IProps> = () => {
    const { metabaseDashboardId } = useParams<{ readonly metabaseDashboardId: string }>();
    const { data: token } = useMetabaseToken(metabaseDashboardId);
    const [isDashboardLoading, setIsDashboardLoading] = useState(true);
    return (
        <Page className="metabase-dashboard">
            <SidebarContainer>
                <CustomReportsSidebar />
                <PageHeader title="Custom Reports">
                    <ShowSidebarButton label="Select Report" />
                </PageHeader>
                <SpinnerUntil<string> data={token} isReady={typeof token !== "undefined"}>
                    {(data) => (
                        <div className="metabase-dashboard__dashboard">
                            {/* The iframe is initially blank while the content is loading so show a spinner */}
                            {isDashboardLoading && <Spinner />}
                            <iframe
                                src={METABASE_SITE_URL.replace(":token", data)}
                                frameBorder="0"
                                width="100%"
                                height="100%"
                                onLoadStart={() => {
                                    setIsDashboardLoading(true);
                                }}
                                onLoad={() => {
                                    setIsDashboardLoading(false);
                                }}
                                title="metabase-dashboard"
                                id="metabase-dashboard-iframe"
                            />
                        </div>
                    )}
                </SpinnerUntil>
            </SidebarContainer>
        </Page>
    );
};

export default memo(MetabaseDashboard);
